'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./input.scss');

var _withPadding = require('../with-padding');

var _withPadding2 = _interopRequireDefault(_withPadding);

var _withFormField = require('../with-form-field');

var _withFormField2 = _interopRequireDefault(_withFormField);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _addon = require('./addon');

var _addon2 = _interopRequireDefault(_addon);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PREFIX = 'prefix';
var SUFFIX = 'suffix';

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: 'getAddonTemplate',
    value: function getAddonTemplate(position) {
      var addon = this.props[position];
      var addonTypeIsString = typeof addon === 'string';
      var addonClasses = (0, _classnames2.default)('input-addon', 'input-addon--' + position, typeof addon !== 'string' && 'input-addon--component');

      if (!addon) {
        return null;
      }

      if (addonTypeIsString) {
        return _react2.default.createElement(_addon2.default, {
          key: position,
          addonType: addon,
          addonClasses: addonClasses,
          tooltip: addon,
          numberOfCharactersToTrim: _utils.CONSTANTS.INPUT_ADDON_MAX_ALLOWED_CHARACTERS,
          dock: 'bottom'
        });
      }

      if (addon.map) {
        // Not applied, when used with password suffix, because buttons there are wrapped in single dom element,

        return _react2.default.createElement(
          'div',
          { className: 'input-addon__array' },
          addon.map(function (add, index) {
            return _react2.default.createElement(
              'span',
              { key: position + '-' + index, className: addonClasses },
              add
            );
          })
        );
      }

      return _react2.default.createElement(
        'span',
        { key: position, className: addonClasses },
        addon
      );
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      var _props = this.props,
          onPressEnter = _props.onPressEnter,
          onKeyUp = _props.onKeyUp;

      if (event.key === _utils.KEYS.ENTER && onPressEnter) {
        onPressEnter();
      }

      if (onKeyUp) {
        onKeyUp(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _objectWithoutProperties(this.props, []);
      // TODO onPressEnter remove


      var onRefsReady = props.onRefsReady,
          prefix = props.prefix,
          suffix = props.suffix,
          onPressEnter = props.onPressEnter,
          propsToPropagate = _objectWithoutProperties(props, ['onRefsReady', 'prefix', 'suffix', 'onPressEnter']);

      return [this.getAddonTemplate(PREFIX), _react2.default.createElement('input', _extends({
        onKeyUp: this.handleKeyUp.bind(this),
        key: 'input',
        ref: function ref(input) {
          if (onRefsReady) {
            onRefsReady(input);
          }
        }
      }, propsToPropagate)), this.getAddonTemplate(SUFFIX)];
    }
  }]);

  return Input;
}(_react2.default.Component);

Input.propTypes = {
  suffix: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.node]),
  prefix: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.node]),
  onPressEnter: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func
};

exports.default = (0, _withFormField2.default)((0, _withPadding2.default)(Input));